export const SetupIncompleteNotificationDataHooks = {
  container: 'setup-incomplete-notification-container',
  description: 'setup-incomplete-notification-description',
};
